"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Check_1 = __importDefault(require("@mui/icons-material/Check"));
const material_1 = require("@mui/material");
const lodash_1 = require("lodash");
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const rolesQuery_1 = require("../../../../queries/rolesQuery");
const zustandStore_1 = require("../../../../zustandStore");
const customButton_1 = __importDefault(require("../../../atoms/button/customButton"));
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const drawerAside_1 = __importDefault(require("../../../organisms/drawerAside"));
const logger = (0, pino_1.default)();
const addAdmins = ({ admins, addRoleToUser, setNotification, invitePeopleSetRoleId }) => {
    try {
        const saveAdminPromises = admins.map(admin => addRoleToUser.mutateAsync({
            userId: admin.userId,
            roleId: appConstants_1.overviewConstants.COMPANY_ADMIN,
            securityGroupId: admin.companyAccountId,
        }));
        return Promise.all(saveAdminPromises);
    }
    catch (error) {
        logger.error({ error });
        setNotification([
            {
                type: strings_1.notificationStrings.WARNING,
                message: strings_1.companySettingsOverviewStrings.ADD_ADMIN_ERROR,
            },
        ]);
        return Promise.reject(new Error(strings_1.companySettingsOverviewStrings.ADD_ADMIN_ERROR));
    }
    finally {
        invitePeopleSetRoleId('');
    }
};
const addSelectedAdmins = ({ teamOwners, addRoleToUser, setNotification, invitePeopleSetRoleId }) => {
    const admins = teamOwners.filter((user) => {
        const loggedUser = (0, lodash_1.clone)(user);
        if (loggedUser.selected) {
            loggedUser.roles = [
                ...loggedUser.roles,
                {
                    roleId: appConstants_1.overviewConstants.COMPANY_ADMIN,
                    securityGroupId: loggedUser.companyAccountId,
                    securityGroupTypeId: appConstants_1.overviewConstants.SECURITY_GROUP_TYPE_COMPANY,
                },
            ];
            loggedUser.isNew = true;
            delete loggedUser.selected;
            return loggedUser;
        }
        return false;
    });
    void addAdmins({ admins, addRoleToUser, setNotification, invitePeopleSetRoleId });
};
const selectUser = ({ loggedUser, teamOwners, setTeamOwners }) => {
    const updatedUsers = teamOwners.map((admin) => ({
        ...admin,
        selected: loggedUser?.userId === admin.userId ? !admin.selected : admin.selected,
    }));
    setTeamOwners(updatedUsers);
};
const renderMenuOptions = ({ teamOwners, addRoleToUser, setIsAddAdminAsideOpen, setIsInvitePeopleAsideOpen, setTeamOwners, setNotification, invitePeopleSetRoleId, }) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.MenuList, { className: "ts-user-menu", "data-ts": "Menu", style: { paddingBottom: '20px' }, children: teamOwners.map(entry => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { className: entry.selected ? 'ts-checked' : '', children: (0, jsx_runtime_1.jsx)(customButton_1.default, { id: entry?.userId, sub: entry?.email, name: entry?.fullName, selected: entry?.selected, onClick: () => selectUser({ loggedUser: entry, teamOwners, setTeamOwners }), icon: (0, jsx_runtime_1.jsx)(Check_1.default, { "ts-variant": "checkIcon" }) }) }, entry.userId))) }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { width: '100%', marginTop: 'auto' }, children: (0, jsx_runtime_1.jsxs)(material_1.Stack, { spacing: 1, children: [teamOwners.length > 0 && ((0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "addSelected-btn", color: uiConstants_1.UI_BUTTON_PRIMARY, disabled: !teamOwners.some(item => item.selected === true), label: strings_1.companySettingsOverviewStrings.ADD_SELECTED_BUTTON_TEXT, onClick: () => {
                                addSelectedAdmins({ teamOwners, addRoleToUser, setNotification, invitePeopleSetRoleId });
                                setIsAddAdminAsideOpen(false);
                            } })), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "inviteAdmin-btn", color: 'secondary', label: strings_1.companySettingsOverviewStrings.INVITE_ADMIN_BUTTON_TEXT, onClick: () => {
                                setIsAddAdminAsideOpen(false);
                                setIsInvitePeopleAsideOpen(true);
                            } }), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "cancel-btn", color: 'secondary', label: strings_1.companySettingsOverviewStrings.CANCEL_BUTTON_TEXT, onClick: () => {
                                setIsAddAdminAsideOpen(false);
                                setIsInvitePeopleAsideOpen(false);
                            } })] }) })] }));
};
const AddCompanyAdminAside = () => {
    const { setIsInvitePeopleAsideOpen, setIsAddAdminAsideOpen, setTeamOwners, invitePeopleSetRoleId, setNotification } = (0, zustandStore_1.useZustand)();
    const isOpenAddAdminAside = (0, zustandStore_1.useZustand)(state => state.aside.addAdminAside.isOpen);
    const teamOwners = (0, zustandStore_1.useZustand)(state => state.team.owners);
    const addRoleToUser = (0, rolesQuery_1.useAddRoleToUserQuery)();
    (0, react_1.useEffect)(() => {
        invitePeopleSetRoleId(appConstants_1.overviewConstants.COMPANY_ADMIN);
    }, [invitePeopleSetRoleId, isOpenAddAdminAside]);
    return ((0, jsx_runtime_1.jsx)(drawerAside_1.default, { id: 'addCompanyAdminAside', title: strings_1.companySettingsOverviewStrings.ADD_ADMIN_TITLE, open: isOpenAddAdminAside, onClose: () => {
            setIsAddAdminAsideOpen(false);
            setIsInvitePeopleAsideOpen(false);
        }, footerButtons: null, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { component: "form", autoComplete: "off", style: { display: 'flex', flexDirection: 'column', height: '100%' }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "body1", children: strings_1.companySettingsOverviewStrings.ADD_ADMIN_ASIDE_INFO }), renderMenuOptions({
                    teamOwners,
                    addRoleToUser,
                    setIsAddAdminAsideOpen,
                    setIsInvitePeopleAsideOpen,
                    setTeamOwners,
                    setNotification,
                    invitePeopleSetRoleId,
                })] }) }));
};
exports.default = AddCompanyAdminAside;
